export const TaskDrawerActionsEnum = {
  VIEW_MODE: {
    EDIT_NAME: {
      key: 5,
      value: 'edit',
      icon: 'mdi mdi-pencil-outline',
      normal_btn: true,
    },
    DELETE: {
      key: 6,
      value: 'delete',
      icon: 'mdi mdi-delete-outline',
      normal_btn: true,
    },
  },
  CREATE_MODE: {
    DISCARD: {
      key: 7,
      value: 'discard',
      icon: 'mdi mdi-delete-outline',
      normal_btn: true,
    },
  },
  EDIT_MODE: {
    SAVE: {
      key: 8,
      value: 'save',
      icon: 'mdi mdi-check',
      normal_btn: true,
    },
    DISCARD_EDIT: {
      key: 9,
      value: 'edit-off',
      icon: 'mdi mdi-pencil-outline',
      normal_btn: true,
    },
  },
};
